import * as React from 'react';

import { ErrorBoundary } from '@hotjar/error-handler';
import { useCurrentSiteId } from '@hotjar/site';

import type { HighlightCreatorProps } from './HighlightCreator';
import { HighlightCreator } from './HighlightCreator';

interface HighlightCreatorContainerProps
  extends Omit<
    HighlightCreatorProps,
    | 'currentOrganization'
    | 'currentSiteId'
    | 'currentUser'
    | 'highlightedRegion'
    | 'isActiveHighlightingEnabled'
    | 'onCancel'
  > {
  highlightsState: {
    deactivate: () => void;
    discardRegion: () => void;
    highlightedRegion: HighlightCreatorProps['highlightedRegion'];
    isActive: boolean;
  };
}

export const HighlightCreatorContainer = ({
  canvasRef,
  height,
  highlightsState,
  screenshotSourceUrl,
  width,
  filters,
}: HighlightCreatorContainerProps): React.ReactElement | null => {
  const currentSiteId = useCurrentSiteId();

  const handleOnCancel = () => {
    if (highlightsState.highlightedRegion) {
      highlightsState.deactivate();
    }

    highlightsState.discardRegion();
  };

  const handleOnSave = () => {
    highlightsState.discardRegion();
  };

  if (!currentSiteId) {
    // TODO: Handler missing user or error correctly
    return null;
  }

  return (
    <ErrorBoundary squadSentryTag="workflow">
      <HighlightCreator
        canvasRef={canvasRef}
        highlightedRegion={highlightsState.highlightedRegion}
        currentSiteId={currentSiteId}
        height={height}
        isActiveHighlightingEnabled={highlightsState.isActive}
        onCancel={handleOnCancel}
        onSave={handleOnSave}
        screenshotSourceUrl={screenshotSourceUrl}
        width={width}
        filters={filters}
      />
    </ErrorBoundary>
  );
};
